import { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

UOMSelectMenu.propTypes = {
  params: PropTypes.object,
  changeUOM: PropTypes.func
}

export default function UOMSelectMenu({ params, changeUOM }) {
  const [menuAnchor, setMenuAnchor] = useState(null);
 
  const handleClose = (uom) => {
    setMenuAnchor(null);
    changeUOM(params, uom);
  };

  return (<>
    <Button onClick={(event) => setMenuAnchor(event.currentTarget)} variant="outlined">
      {params.data.activeUOM?.uomType}
    </Button>
    {params.data.uomTypes?.length > 1 ? <Menu
      anchorEl={menuAnchor}
      open={Boolean(menuAnchor)}
      onClose={() => setMenuAnchor(null)}
    >
      {params.data.uomTypes.map(uom => <MenuItem key={uom.id} onClick={() => handleClose(uom)}>{uom.uomType}{uom.price !== null ?
        ` - ${uom.price.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}` : ""}</MenuItem>)}
    </Menu> : ""}
  </>);
}
